/*
 * 文件EN: badRecord.js,
 * 文件CN: 不良列表,
 * 创建时间: Friday, 15th May 2020 5:17:26 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
import * as Models from '@/api/T3/DHGL/badRecord'

export default {
  namespaced: true,
  actions: {
    // 获取列表
    getList(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },

    /**
     * @desc 根据商户号查询商户额度
     * @method GET
     * @param { merNo:""}
     */
    getBalance(ctx, payload) {
      return Models.getBalance(payload).then(res => {
        return res && res.status === 200 ? res.data || {} : {}
      })
    },

    /**
     * @desc 查询商户支付终端信息
     * @method GET
     * @param { merNo:""}
     */
    getMerchantStatus(ctx, payload) {
      return Models.getMerchantStatus(payload).then(res => {
        return res && res.status === 200 && res.data ? res.data : null
      })
    },

    /**
     * @desc 根据商户号，查询触发的逾期记录
     * @method GET
     * @param { merNo:""}
     */
    overdueRecord(ctx, payload) {
      return Models.overdueRecord(payload).then(res => {
        return res && res.status === 200 && res.data ? res.data : null
      })
    },

    /**
     * @desc 获取该商户下所有卡-额度授信账户
     * @method GET
     * @param { merNo:""}
     */
    queryCardList(ctx, payload) {
      return Models.queryCardList(payload).then(res => {
        return res && res.status === 200 && res.data ? res.data : null
      })
    },

    /**
     * @desc 获取该商户聚合支付信息
     * @method GET
     * @param { merId:""}
     */
    queryUnionPayment(ctx, payload) {
      return Models.queryUnionPayment(payload).then(res => {
        return res && res.status === 200 && res.data ? res.data : {}
      })
    },
    /**
     * @desc 根据商户号，查询触发的风控记录
     * @method GET
     * @param { merId:""}
     */
    riskRecord(ctx, payload) {
      return Models.riskRecord(payload).then(res => {
        return res && res.status === 200 && res.data ? res.data : null
      })
    },
    /**
     * @desc 根据商户id，查询审批信息
     * @method GET
     * @param { merId:""}
     */
    getMerchantApply(ctx, payload) {
      return Models.getMerchantApply(payload).then(res => {
        return res && res.status === 200 && res.data ? res.data : null
      })
    }
  }
}
